//NOTE: must be loaded after google-analytics.js and marketo script

//--------------------------------------------------------
// STYLING
//--------------------------------------------------------

window.gptw = window.gptw || {};
window.gptw.forms = window.gptw.forms || {};

function destyleMktoForm(mktoForm) {
	console.log('GPTW: removing marketo styling');

	var formEl = mktoForm.getFormElem()[0],
		arrayFrom = Function.prototype.call.bind(Array.prototype.slice);

	jQuery('.mktoClear, .mktoGutter, .mktoOffset').remove();

	// remove element styles from <form> and children
	var styledEls = arrayFrom(formEl.querySelectorAll('[style]')).concat(formEl);
	styledEls.forEach(function (el) {
		el.removeAttribute('style');
	});

	// disable remote stylesheets and local <style>s
	var styleSheets = arrayFrom(document.styleSheets);

	styleSheets.forEach(function (ss) {
		if ([mktoForms2BaseStyle, mktoForms2ThemeStyle].indexOf(ss.ownerNode) != -1 || formEl.contains(ss.ownerNode)) {
			ss.disabled = true;
		}
	});

	document.getElementById('mktoForms2BaseStyle').disabled = true;
	document.getElementById('mktoForms2ThemeStyle').disabled = true;

	//apply classes to wrappers to identify contents for styling
	jQuery('form.mktoForm .mktoFormRow').each(function () {
		if (jQuery(this).find('.mktoCheckboxList input').length === 1) {
			jQuery(this).addClass('single-checkbox');
		}
	});
}

if (typeof MktoForms2.whenRendered !== 'undefined') {
	MktoForms2.whenRendered(function (form) {
		console.log(`GPTW: marketo form ${form.getId()} rendered, destyling and firing up select2...`);

		destyleMktoForm(form);

		jQuery(window).resize(function () {
			destyleMktoForm(form);
		});

		//inbuilt method to get the form elements
		var formElement = form.getFormElem()[0];

		//hide honeypot
		jQuery(formElement).find('#honeypot').parents('.mktoFormRow').hide();

		//hide rows with hidden fields
		jQuery(formElement)
			.find('.mktoFormRow')
			.each(function () {
				jQuery(this)
					.find('input')
					.each(function () {
						if (this.type === 'hidden') {
							jQuery(this).parent().hide();
						}
					});
			});

		//enable select2 in marketo
		/* jQuery(formElement).find('select').select2({

            minimumResultsForSearch: -1, //hide the search box

        }); */
	});
}

if (typeof MktoForms2.onValidate !== 'undefined') {
	MktoForms2.onValidate(function (form) {
		jQuery('select').trigger('change');
	});
}

//--------------------------------------------------------
// MEASUREMENT
//--------------------------------------------------------

if (typeof MktoForms2.whenReady !== 'undefined') {
	MktoForms2.whenReady(function (form) {
		let formId = form.getId();

		console.log('GPTW: marketo form ' + formId + ' ready', form);

		//field metrics
		var formElement = form.getFormElem();

		window.gptw.forms[formId] = {};

		window.gptw.forms[formId].formElement = formElement[0];

		var fields = jQuery(formElement).first().find('input, textarea, select').not('input[type=hidden]');

		window.gptw.forms[formId].fieldCount = fields.length;

		console.log('GPTW: ' + fields.length + ' fields detected for marketo form ' + formId, fields);

		fields.each(function () {
			jQuery(this).change(function () {
				console.log('GPTW: marketo form ' + formId + ' form field change detected');

				if (!(this.value === '')) {
					jQuery(this).addClass('field-complete');
				} else {
					jQuery(this).removeClass('field-complete');
				}
			});
		});

		//abandonment metrics
		jQuery(window).on('beforeunload', function () {
			if (typeof window.gptw.forms !== 'undefined') {
				for (form in window.gptw.forms) {
					//discount the newsletter form
					if (form === '1034') {
						continue;
					}

					window.gptw.forms[form];

					var completedFields = jQuery(window.gptw.forms[form].formElement).find('.field-complete').length;

					var percentageComplete = Math.round((completedFields / window.gptw.forms[form].fieldCount) * 100);

					//TODO do not trigger if form is marked as complete
					if (window.gptw.forms[form].formCompleted !== true) {
						gptwGA.event('Forms', 'Abandonment', form, percentageComplete);
					}
				}
			}
		});

		form.onSuccess(function (form) {
			let formId = form.formid;

			console.log('GPTW: marketo form ' + formId + ' success - triggering measurement', form);

			window.gptw.forms[formId].formCompleted = true;

			gptwGA.event('Form', 'Submit', formId);
			gptwGA4.event('form_submit', { id: formId });

			return false; //to prevent page redirect / reload
		});
	});
}
